import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

const mobile = (styles: any) => css`
  ${({ theme }) => theme?.isWidget && styles};

  @media (max-width: 768px) {
    ${styles}
  }
`;

export const RangeWrap = styled.div`
  display: flex;
  gap:  ${toRem(8)};
  padding: ${toRem(16)} ${toRem(16)} 0 ${toRem(16)};;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ${mobile(css`
    padding: ${toRem(16)} 0 ${toRem(16)} 0;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `)}
`;
